export default __webpack_public_path__ + "static/media/presentations.af080e09.png";